import ApiError from "../../errors/ApiError";

export class UnlinkCustomerHostawayError extends ApiError {
  constructor() {
    super("Failed to unlink customer from Hostaway");
  }
}
